module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"prev":"vorheriges Bild","next":"nächstes Bild"},"en":{"prev":"previous picture","next":"next picture"}}')
  delete Component.options._Ctor
}
